const settings = {
  isSplash: true,
  useCustomCursor: false,
  googleTrackingID: "UA-216634483-1",
};

//Home Page
const greeting = {
  title: "Hello 👋.",
  title2: "Yogesh",
  logo_name: "YG",
  nickname: "Yogi",
  full_name: "Yogesh Gurjar",
  subTitle:
    "A passionate Data scientist who thrives on building scalable end to end data-driven products.",
  resumeLink:
    "https://drive.google.com/file/d/1C2JZHnmDVw_KhB-rA2I6SRcdmMAwaDYT/view?usp=sharing",
  mail: "mailto:yogesh.grjr4@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/zzzhacker",
  linkedin: "https://www.linkedin.com/in/yogesh-gurjar/",
  gmail: "yogesh.grjr4@gmail.com",
  facebook: "https://www.facebook.com/YogeshGurjar007/",
  twitter: "https://twitter.com/GrjrGurjar",
};

const skills = {
  data: [
    {
      title: "Data Science",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Bringing Actionable insights from real-word data using Descriptive and Diagnostic Analytics.",
        "⚡ Building Large Scale Fast recommendation engines.",
        "⚡ Developing Edge device models with adequate KPIs and low computational cost.",
        "⚡ Building highly scalable model deployment services.",
        "⚡ Providing robust predictive model monitoring solutions.",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "simple-icons:tensorflow",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "Pytorch",
          fontAwesomeClassname: "simple-icons:pytorch",
          style: {
            color: "#EE4C2C",
          },
        },
        {
          skillName: "scikit-learn",
          fontAwesomeClassname: "simple-icons:scikit-learn",
          style: {
            color: "#F7931E",
          },
        },
        {
          skillName: "Scipy",
          fontAwesomeClassname: "simple-icons:scipy",
          style: {
            color: "#8CAAE6",
          },
        },
        {
          skillName: "Plotly",
          fontAwesomeClassname: "simple-icons:plotly",
          style: {
            color: "#3F4F75",
          },
        },
        {
          skillName: "Pandas",
          fontAwesomeClassname: "simple-icons:pandas",
          style: {
            color: "#150458",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            color: "#D00000",
          },
        },
        {
          skillName: "Numpy",
          fontAwesomeClassname: "simple-icons:numpy",
          style: {
            color: "#013243",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
        {
          skillName: "R",
          fontAwesomeClassname: "simple-icons:r",
          style: {
            color: "#276DC3",
          },
        },
        {
          skillName: "MATLAB",
          fontAwesomeClassname: "simple-icons:octave",
          style: {
            color: "#0790C0",
          },
        },
        {
          skillName: "ONNX",
          fontAwesomeClassname: "simple-icons:onnx",
          style: {
            color: "#005CED",
          },
        },
      ],
    },
    {
      title: "CV, NLP and Data Engieering",
      fileName: "CVImg",
      skills: [
        "⚡ Experience working on Image classification, Face recognition, Person tracking, etc.",
        "⚡ Developing Pose estimation, Pose tracking, Object detection, and Object tracking solutions.",
        "⚡ Building Custom use case Conversational bots on custom Models using Rasa, DialogFlow, etc.",
        "⚡ Providing Large Scale Data Engineering Solutions with efficient resource usages.",
      ],
      softwareSkills: [
        {
          skillName: "Opencv",
          fontAwesomeClassname: "simple-icons:opencv",
          style: {
            color: "#5C3EE8",
          },
        },
        {
          skillName: "Dialogflow",
          fontAwesomeClassname: "simple-icons:dialogflow",
          style: {
            color: "#FF9800",
          },
        },
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "simple-icons:tensorflow",
          style: {
            color: "#FF6F00",
          },
        },
        {
          skillName: "Pytorch",
          fontAwesomeClassname: "simple-icons:pytorch",
          style: {
            color: "#EE4C2C",
          },
        },
        {
          skillName: "Apache Spark",
          fontAwesomeClassname: "simple-icons:apachespark",
          style: {
            color: "#E25A1C",
          },
        },
        {
          skillName: "Apache Hadoop",
          fontAwesomeClassname: "simple-icons:apachehadoop",
          style: {
            color: "#66CCFF",
          },
        },
        {
          skillName: "Apache Airflow",
          fontAwesomeClassname: "simple-icons:apacheairflow",
          style: {
            color: "#66CCFF",
          },
        },
        {
          skillName: "Cassandra",
          fontAwesomeClassname: "simple-icons:cassandra",
          style: {
            color: "#1287B1",
          },
        },
        {
          skillName: "RabbitMQ",
          fontAwesomeClassname: "simple-icons:rabbitmq",
          style: {
            color: "#FF6600",
          },
        },
        {
          skillName: "Apache Kafka",
          fontAwesomeClassname: "simple-icons:apachekafka",
          style: {
            color: "white",
          },
        },
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using React, HTML, and CSS.",
        "⚡ Developing Data apps dashboard and UI using Streamlit, Plotly and Dash.",
        "⚡ Creating Application backend and Rest APIs in Flask, Django and FastAPI.",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "FastAPI",
          fontAwesomeClassname: "simple-icons:fastapi",
          style: {
            color: "#009688",
          },
        },
        {
          skillName: "Django",
          fontAwesomeClassname: "simple-icons:django",
          style: {
            color: "#092E20",
          },
        },
        {
          skillName: "Flask",
          fontAwesomeClassname: "simple-icons:flask",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "Streamlit",
          fontAwesomeClassname: "simple-icons:streamlit",
          style: {
            color: "#FF4B4B",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms.",
        "⚡ Setup Databases and Data warehouses using Postgres, Mysql, Firebase, GCP Bigquery, S3 buckets, etc. on Cloud.",
        "⚡ Developing Rest API and microservices for model serving on Cloud.",
        "⚡ Building Docker images and Kubernetes Infra to deploy automated scalable services on Cloud.",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
        {
          skillName: "Github Action",
          fontAwesomeClassname: "simple-icons:githubactions",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "University of Texas at Arlington",
      subtitle: "Master of Science in COmputer Science ",
      logo_path: "utalogo.png",
      alt_name: "UTA",
      duration: "2021 - Present",
      descriptions: [
        "⚡ I'm currently pursuing my Masters in Computer Science.",
        "⚡ I have taken courses related to Data Analytics, Neural Network, Computer vision, Big Data, and Distributed systems.",
        "⚡ I am working on my thesis for Semantic role identification, classification, and their evaluation strategies.",
      ],
      website_link: "https://www.uta.edu/",
    },
    {
      title: "Jabalpur Engineering College",
      subtitle: "Bachelore of Engineering in Computer science",
      logo_path: "jeclogo.gif",
      alt_name: "JEC",
      duration: "2015 - 2019",
      descriptions: [
        "⚡ I have studied core subjects like Data Structures, DBMS, Networking, Security, etc.",
        "⚡ I have also completed various online courses Statistics, Machine learning, Data Science and Deep learning, etc.",
        "⚡ I have completed my major project on building a tool for pneumothorax detection using X-ray images using CNN with a User Interface.",
      ],
      website_link: "https://www.jecjabalpur.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Deep Learning Specialization",
      subtitle: "DeepLearning.ai",
      logo_path: "dlai.png",
      certificate_link:
        "https://coursera.org/share/af997a9c34a53d1300fb52d37c566d12",
      alt_name: "DeepLearning.ai, Coursera",
      color_code: "#C5E2EE",
      // color_code: "#E2405F",
    },
    {
      title: "Mathematics for Machine Learning Specialization",
      subtitle: "Imperial College London, Coursera",
      logo_path: "imcllogo.jpg",
      certificate_link:
        "https://coursera.org/share/2285f0572ba92bb5cde27cac7004cfd2",
      alt_name: "Math for ML",
      color_code: "#C5E2EE",
    },
    {
      title: "Analytics Edge",
      subtitle: "MIT, EDX",
      logo_path: "mitlogo.jpeg",
      certificate_link: "",
      alt_name: "EDX",
      color_code: "#C5E2EE",
    },
    {
      title: "Statistical Learning",
      subtitle: "Stanford Online",
      logo_path: "stanfordlogo.png",
      certificate_link:
        "https://verify.lagunita.stanford.edu/SOA/a17e0f6f6e3144a7a677e89870511d7b/",
      alt_name: "statstical learning",
      color_code: "#C5E2EE",
    },
    {
      title: "SQL Essential Training",
      subtitle: "Linkedin Learning",
      logo_path: "inlearning_logo.jpg",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/b97d24deeaf993347a8745913258951e531f4dfb780017cb848804282a73e3bf",
      alt_name: "Linkedin Learning",
      color_code: "#C5E2EE",
    },
    {
      title: "Machine Learning",
      subtitle: "Stanford University, Coursera",
      logo_path: "stanfordcoursera.png",
      certificate_link: "",
      alt_name: "Stanford University, Coursera",
      color_code: "#C5E2EE",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work and Internship",
  description:
    "I have 3 Years of working experience building small to large scale AI and Data driven products in Computer vision, NLP and Data Science domains.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work Experience",
      experiences: [
        {
          title: "Data Scientist",
          company: "Brane Enterprises",
          company_url: "https://nslhub.com/",
          logo_path: "branelogo.png",
          duration: "July 2020 - July 2021",
          location: "Hyderabad, IN",
          description: [
            "⚡ Improved ​recommendation speed for search queries by 100% using Faiss and utilizing GPUs.",
            "⚡ Developed a scalable recommendation system with Multiple GPU scaling capabilities handling 5X concurrent requests.",
            "⚡ Develop a zero-shot classification approach to improve the previous noun phrase classification method by 10%.",
            "⚡ Improve the response time of the system 6X by designing and building a new architecture normalizing complex service to multiple independent microservices for model servicing and KNN query searching etc.",
            "⚡ Worked on word and noun phrase disambiguation with contextual word embeddings and knowledge graphs.",
          ],
          color: "#0071C5",
        },
        {
          title: "Data Scientist",
          company: "Knorex",
          company_url: "https://www.knorex.com/",
          logo_path: "knorexlogo.png",
          duration: "June 2019 - June 2020",
          location: "Pune, IN",
          description: [
            "⚡ Built Scalable systems for Audience Profiling and lookalike modeling with Spark to handle more than 1 Million rows / Day of information to Optimize CPC and CPM.",
            "⚡ Bidding on model-generated lookalike audience reduced CPC by 11% and CPM by 34%.",
            "⚡ Worked on a custom Ml Framework with complex data pipeline for data processing, model training, and serving components with TensorFlow serving to reduce deployment time by 75%.",
            "⚡ Improve the response time of the system 6X by designing and building a new architecture normalizing complex service to multiple independent microservices for model servicing and KNN query searching etc.",
            "⚡ Improve the previous Click prediction ( CTR ) model AUC by 6% using the feature engineering and Factorized Neural network models with help of a Rectified ADAM optimizer.",
          ],
          color: "#0071C5",
        },
        {
          title: "Data Scientist(Consultant)",
          company: "Codenscious technologies",
          company_url: "http://codenscious.ai/",
          logo_path: "codensciouslogo.png",
          duration: "March 2018 - June 2019",
          location: "Indore, IN",
          description: [
            "⚡ Built a social profile Analyzer to Filter Out inappropriate not professional images and text resulting in 10X time reduction for inappropriate profile filtering.",
            "⚡ Developed Pose estimation and object tracking systems and increased inference speed by 5X.",
            "⚡ Developed new solutions like Smart-IoT-camera, Baseball tracking Camera, etc on edge devices like Jetson and raspberry PI resulting in 1.5 times more client acquisition.",
            "⚡ Managed Data science Projects and team and improved the turnaround time of POCs by 50% which leads to an increase of 25% revenue(MoM) growth.",
          ],
          color: "#0071C5",
        },
      ],
    },
    {
      title: "Internship Experience",
      experiences: [
        {
          title: "Machine learning Intern",
          company: "Overstock.com",
          company_url: "https://www.overstock.com/",
          logo_path: "overstocklogo.png",
          duration: "May 2022 - Aug 2022",
          location: "Salt Lake City, USA",
          description: [
            "⚡  Built spark data pipeline on GCP Dataproc clusters to process ~ 2 billion JSON records to train a sentence embedding model on 4 million query-product pairs.",
            "⚡ Created a pipeline to retrieve ~ 2 million product features from multiple Bigquery tables.",
            "⚡ Engineered a recommendation system using sentence embedding and the BM25 method, which increased clicks and purchases by 10%.",
          ],
          color: "#0071C5",
        },
        {
          title: "Machine learning Intern",
          company: "Codenscious technologies",
          company_url: "http://codenscious.ai/",
          logo_path: "codensciouslogo.png",
          duration: "March 2018 - June 2019",
          location: "Indore, IN",
          description: [
            "⚡ Solved ​computation resources constraints Object detection problem ​ with SSD, YOLO algos.",
            "⚡ Built a PoC for industrial work to detect missing objects in images from their reference images.",
          ],
          color: "#0071C5",
        },
        {
          title: "Web Developer And Research Intern",
          company: "Indian Road Safety Campaign",
          company_url: "https://irsc.road-safety.co.in",
          logo_path: "irsclogo.png",
          duration: "July 2017 - Aug 2017",
          location: "Delhi, IN",
          description: [
            "⚡ Done the front-end development with bootstrap, HTML, CSS, and javascript and backend development in node.js and work on MongoDB.",
            "⚡ Done Research work on research papers like traffic alert system, Senspeed(remote vehicle speed detection with more accuracy), etc.",
          ],
          color: "#0071C5",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects make use of a vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "profile.png",
    description:
      "You can ping me any where if you are want to chat about new and exciting researches or opprtunities in AI.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "Usally I don't write blogs but I have helpful reading list on Medium and all are welcome to try that.",
    link: "https://medium.com/@yogesh.grjr4",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Arligton, Texas-76013",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+1 6466831976",
  },
};

const projects = {
  data: [
    {
      id: "0",
      name: "ALGODS",
      url: "https://github.com/zzzhacker/ALGODS",
      description:
        "In this Repo I included all Algorithms and Data structure problems and thier solutions I ever encountered",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
      ],
    },
    {
      id: "1",
      name: "Onnx-transformers2",
      url: "https://github.com/zzzhacker/onnx-trasformers2",
      description:
        "Accelerated NLP pipelines for fast inference rocket on CPU AND GPUS. Built with hugging face Transformers Pipeline and ONNX runtime.",
      languages: [
        {
          name: "Pytorch",
          iconifyClass: "simple-icons:pytorch",
          style: {
            color: "#EE4C2C",
          },
        },
        {
          name: "Huggingface",
          iconifyClass: "emojione:hugging-face",
        },
        {
          name: "ONNX",
          iconifyClass: "simple-icons:onnx",
          style: {
            color: "#005CED",
          },
        },
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
      ],
    },
    {
      id: "2",
      name: "Image classification hacks",
      url: "https://github.com/zzzhacker/Image_classfication_hacks",
      description:
        "A single notebook where I try to explain the best practices of to improve Image classification accuracy with proper analysis.",
      languages: [
        {
          name: "Pytorch",
          iconifyClass: "simple-icons:pytorch",
          style: {
            color: "#EE4C2C",
          },
        },
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "Jupyter Notebook",
          iconifyClass: "simple-icons:jupyter",
          style: {
            color: "#F37626",
          },
        },
      ],
    },
    {
      id: "3",
      name: "Airbnb React",
      url: "https://github.com/zzzhacker/Airbnb-React",
      description:
        "In this project, An Airbnb experience page clone is created to learn and implement React props concepts.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
      ],
    },
    {
      id: "4",
      name: "Meme Generator",
      url: "https://github.com/zzzhacker/Meme-Generator",
      description:
        "In This project a meme generator app is built using react to learn various concepts of React.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
      ],
    },
    {
      id: "5",
      name: "MyCarApp",
      url: "https://github.com/zzzhacker/MYcarapp",
      description:
        "In this Project A shiny App is build to select the best car according to users requirement by using dynamic dashboard for convenient selection",
      languages: [
        {
          name: "R",
          iconifyClass: "simple-icons:r",
          style: {
            color: "#276DC3",
          },
        },
      ],
    },
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
